import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { MediumHeader } from '../Header/Header';
import Paragraph from '../../ui/Paragraph/Paragraph';
import styles from './PanelContentHeader.module.css';

export interface PanelContentHeaderProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  icon?: ReactNode;
  headerText?: string | ReactNode;
  paragraphChildren?: ReactNode;
  featureName?: string;
  isLandscape?: boolean;
  headerTextRole?: string;
}

const PanelContentHeader: FC<PanelContentHeaderProps> = ({
  as,
  icon,
  headerText,
  paragraphChildren,
  isLandscape = false,
  headerTextRole,
}) =>
  isLandscape ? (
    <div
      className={clsx({
        [styles.tableCell]: true,
        [styles.alignLeft]: true,
      })}
    >
      <div className={styles.tableCell}>{icon}</div>
      <div
        className={styles.tableCell}
        style={{
          padding: icon ? '0 1rem' : '0 1rem 0 0',
        }}
      >
        {headerText && (
          <MediumHeader as={as} headerTextRole={headerTextRole}>
            {headerText}
          </MediumHeader>
        )}
        <Paragraph
          containerCustomStyle={{
            margin: '0.25rem 0 0 0',
          }}
        >
          {paragraphChildren}
        </Paragraph>
      </div>
    </div>
  ) : (
    <div className={styles.alignCenter}>
      {icon}
      {headerText && (
        <MediumHeader
          as={as}
          headerTextRole={headerTextRole}
          containerCustomStyle={{ margin: '1rem 0 0.5rem 0' }}
        >
          {headerText}
        </MediumHeader>
      )}
      <Paragraph containerCustomStyle={{ margin: 0 }}>
        {paragraphChildren}
      </Paragraph>
    </div>
  );

export default PanelContentHeader;
